import React, { useEffect } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import Users from '../../Users';
import Archived from '../../Archived';
import DateRange from '../../DateRange';
import { Link, useNavigate } from 'react-router';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Spinner } from 'reactstrap';
import useFilter from '../../../hooks/useFilter';
import useNavBar from '../../../hooks/useNavBar';
import LearningPlans from '../../LearningPlans';
import CourseStatuses from '../../CourseStatuses';

export default function LearningPlanReportForm() {
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const users = Users();
    const learningPlans = LearningPlans();
    const courseStatuses = CourseStatuses();
    const archived = Archived();
    const archivedDateRange = DateRange({
        title: '',
        initialHelpText: 'Only archived records within this archive date range will be included.',
        startFieldName: 'archivedFromDate',
        endFieldName: 'archivedToDate',
        filterStartKey: 'archivedFromDate',
        filterEndKey: 'archivedToDate'
    });

    const { filter, setFilter } = useFilter();
    const { loading, setLoading } = useNavBar();
    

    const headers = 
    [
        "Full Name",
        "Training Plan Name",
        "Completion Percentage",
        "Enrollment Status",
        "Hours Required",
        "Hours Completed",
        "Hours Remaining",
        "Course",
        "Session Name",
        "Category",
        "Training Code",
        "Course Type",
        "Enrollment Date",
        "Active From",
        "Active To",
        "Course Completion Date"
    ];    

    useEffect(() => {
        if(!users.loading && !learningPlans.loading && !archived.loading && !archivedDateRange.loading){
            setLoading(false);
        }

        const adjustedHeaders = [
            ...headers,
            ...(users.includeInactiveUsers ? ["User Status"] : []),
            ...(archived.includeArchivedCompletions ? ["ArchivedStatus", "Archived Date", "Archived By"] : [])
        ];

        setFilter({
            users: users.selectedUsers.map(user => user.value),
            groups: users.selectedGroups.map(group => group.value),
            learningPlans: learningPlans.selected.map(learningPlan => learningPlan.value),
            courseStatuses: courseStatuses.selectedStatuses.map(courseStatus => courseStatus.value),
            headers: adjustedHeaders,
            includeArchivedCompletions: archived.includeArchivedCompletions,
            hasArchivedCompletions: archived.hasArchivedCompletions,
            archivedFromDate: archived.includeArchivedCompletions ? archivedDateRange.startDate : null,
            archivedToDate: archived.includeArchivedCompletions ? archivedDateRange.endDate : null,

            selectAllUsers: users.selectAll,
            formUsers: users.users,            
            formGroups: users.groups,
            includeInactiveUsers: users.includeInactiveUsers,
            formLearningPlans: learningPlans.learningPlans,
            formCourseStatuses: courseStatuses.courseStatuses,
            formSelectAllCourseStatuses: courseStatuses.selectAll
        });
    }, [users.loading,
        users.selectAll,
        users.selectedUsers,
        users.users,
        users.selectedGroups,
        users.groups,
        users.includeInactiveUsers,
        learningPlans.loading,
        learningPlans.selected, 
        learningPlans.learningPlans,
        courseStatuses.loading,
        courseStatuses.selectAll,
        courseStatuses.selectedStatuses,
        courseStatuses.courseStatuses,
        archived.loading,
        archived.includeArchivedCompletions,
        archived.hasArchivedCompletions,
        archivedDateRange.loading,
        archivedDateRange.startDate,
        archivedDateRange.endDate
    ]
    ); 

    const handleSubmit = async (e) => {
        e.preventDefault();

        const sendfilter = (
            (
                { users, groups, learningPlans, courseStatuses, headers, includeArchivedCompletions, hasArchivedCompletions, archivedFromDate, archivedToDate }) =>
                ({ users, groups, learningPlans, courseStatuses, headers, includeArchivedCompletions, hasArchivedCompletions, archivedFromDate, archivedToDate })
        )(filter);

        try{
            await axiosPrivate.post('api/reports/learningplan', sendfilter);
            navigate('/reports');
        }
        catch(err){
            console.log(err);
        }
    }

    return (
        loading ? <Spinner variant="primary" animation="border" role="status" className='custom-spinner'/> :
        <Container>
            <Col>
                <FormGroup>
                    <Card>
                        <CardBody>                 
                            <FormGroup>
                                {learningPlans.render}
                            </FormGroup>
                        </CardBody>
                    </Card>
                </FormGroup>
                <FormGroup>                            
                    <Card>
                        <CardBody>
                            <FormGroup>
                                {users.render}
                            </FormGroup>
                        </CardBody>
                    </Card>  
                </FormGroup>   
                    <FormGroup>
                        <Card>
                            <CardBody>
                                <FormGroup>
                                    {courseStatuses.render}
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </FormGroup>
                    {
                        archived.hasArchivedCompletions ?
                            <FormGroup>
                                <Card>
                                    <CardBody>
                                        <FormGroup>
                                            {archived.render}
                                            {
                                                archived.includeArchivedCompletions ?
                                                    <div className='mt-3'>
                                                        {archivedDateRange.render}
                                                    </div>
                                                    : null
                                            }
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                            </FormGroup>
                            : null
                    }
            </Col>
            <footer>
                <Form onSubmit={handleSubmit}>
                    <Button color="primary">Generate Report</Button>
                    <Link to="/">
                        <Button className='btn-danger'>Back</Button>
                    </Link>
                </Form>
            </footer>
        </Container>
    );
}